import { AsyncCallArgs, CircularLoader, useAsyncCall } from "@duosoftbg/nacid-components";
import React, { useEffect, useState } from "react";
import { getUserInfo } from "../../../../../axios/api/services";
import UserDataSections from "./sections/UserDataSections";
import SpecialActionsSection from "./sections/specialActions/SpecialActionsSection";

const MyAccount = () => {
  const { asyncCall } = useAsyncCall();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: getUserInfo(),
      onSuccess: (response) => {
        setUser(response);
      },
      onError: () => {
        setUser(null);
      },
    };
    asyncCall(asyncCallArgs);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!user && <CircularLoader />}
      {user && (
        <>
          <UserDataSections user={user} />
          <SpecialActionsSection />
        </>
      )}
    </>
  );
};
export default MyAccount;
